// extracted by mini-css-extract-plugin
export default {"footer_links":"daodao-brand-footer-HorizontalLinkSection__footer_links--khK-g","ui_link":"daodao-brand-footer-HorizontalLinkSection__ui_link--RbwDj"};